// @flow
import { useTranslation } from 'next-i18next'
import { CoimexButton } from '../../components/CoimexButton/CoimexButton'
export const CardPlane = (props) => {
  const { t, i18n } = useTranslation();

  const item= props.item
  return (
    <div className="bg-whiteLatic mt-3 md:w-full w-11/12 mx-auto cursor-pointer h-40 rounded-lg pt-4 px-4 select-none">
      <h4 className="text-Primary6d text-base font-Montserrat font-bold">
        {item?.type}
      </h4>
      <p className="text text-base text-PrimaryA7">{item?.quota.posts.count }  {t("Price.3")}</p>
      <p className="text text-base text-PrimaryA7">{item?.quota.categories}  {t("Price.4")}</p>
      <div className="flex flex-row-reverse mt-4  items-center justify-between">
        <CoimexButton className="w-24" onClick={()=>props.onClick(item)}>
        {t("Price.2")}
        </CoimexButton>
        <p className="text text-base text-Primary33">${item?.price}</p>
      </div>
    </div>
  )
}
